module.exports = __webpack_public_path__ + "img/sugon.99cb1d8f.svg";